import { Link as RouterLink } from 'react-router-dom'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import { paletteSuccessMain } from '@/theme/designTokens'

const createButtonSx = {
  borderRadius: '8px',
  px: 2,
  py: 1.25,
  bgcolor: paletteSuccessMain,
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: '-0.15px',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': { bgcolor: '#0b8560' },
} as const

type Props = Readonly<{
  /** Admin or Editor may create research (BFP-999). */
  canCreate: boolean
  /**
   * Campaigns tab → campaign setup (skip Get Started chooser).
   * Direct tab → quick instrument create.
   * Dashboard “Build New Research” still goes to Get Started.
   */
  to?: string
  label?: string
  testId?: string
}>

export function CampaignListToolbar({
  canCreate,
  to = '/campaigns/new/setup',
  label = 'Build New Research',
  testId = 'campaign-list-create',
}: Props) {
  if (!canCreate) return null

  return (
    <Button
      variant="contained"
      disableElevation
      component={RouterLink}
      to={to}
      data-testid={testId}
      startIcon={<AddIcon sx={{ fontSize: 18 }} />}
      sx={createButtonSx}
    >
      {label}
    </Button>
  )
}
